module.exports = "<div class=\"router-parent\">\n  <router-menu></router-menu>\n  <router-view class=\"router-flex-child\"></router-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app.html
// module id = 312
// module chunks = 0